
























import {Component, Watch, Prop, Mixins} from 'vue-property-decorator'
import {MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import {FileObject} from 'image-compressor.js'
import {AppConfig} from '@/config/app.config'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import * as Helper from '@/helpers'

@Component
export default class ItNfCsvUpload extends Mixins(MixinUpload) {
  @Prop({type: Object, required: true}) value!: DeliveryRequest
  @Prop({type: String}) title?: string

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  @Watch('files')
  async filesEvent(files: FileObject[]) {
    if (!files.length) return

    const blueprint = AppConfig.csvBlueprint.queryNf
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    this.value.docs = data.map((item) => item.nf).join()
    this.value.allDocs.items = data.map((item) => Helper.buildResource(item.nf, item.nf))
    this.files = []
  }
}
